import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Licitacao from '../../../../components/auth/licitacao/listar/licitacao'
import Head from '../../../../components/head'
import Footer from '../../../../components/footer'


function LicScreen () {
    return (
        <Fragment>
            <Head titulo="Visualizando Licitação" />
            <HeaderLogged />
            <Container>
                <Licitacao />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default LicScreen;